"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BADGE_TYPE = void 0;
exports.BADGE_TYPE = {
    UPDATED: 'Updated',
};
